module.exports = __webpack_public_path__ + "img/papillary-reaction-4.2bb9e2fe.jpg";